export const SET_PADDLE_LOADING = 'SET_PADDLE_LOADING';
export const GET_PADDLE_PRODUCTS = 'GET_PADDLE_PRODUCTS';
export const GET_PADDLE_PRICES = 'GET_PADDLE_PRICES';
export const SET_UPDATE_SUBSCRIPTION = 'SET_UPDATE_SUBSCRIPTION';
export const CLEAN_UPDATE_SUBSCRIPTION = 'CLEAN_UPDATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const GET_USER_TRANSACTIONS = 'GET_USER_TRANSACTIONS';
export const GET_USER_PAYMENT_METHOD = 'GET_USER_PAYMENT_METHOD';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';